import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import apiMiddleware from "../api/apiMiddleware";
import {
  getServicesFromUser,
  hasSupplierService,
  syncSupplierUser,
} from "../utils/supplierServices";

export const useSupplierServices = () => {
  const [localVersion, setLocalVersion] = useState(0);

  useEffect(() => {
    const refresh = () => setLocalVersion((version) => version + 1);

    window.addEventListener("supplier-profile-updated", refresh);
    window.addEventListener("storage", refresh);

    return () => {
      window.removeEventListener("supplier-profile-updated", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  const { data: profileData } = useQuery({
    queryKey: ["supplierProfile"],
    queryFn: async () => {
      const response = await apiMiddleware.get("/supplier/profile");
      return response.data;
    },
    staleTime: 30_000,
    retry: 1,
  });

  useEffect(() => {
    if (profileData?.data?.user) {
      syncSupplierUser(profileData.data.user);
    }
  }, [profileData]);

  const services = useMemo(() => {
    if (profileData?.data?.user) {
      return getServicesFromUser(profileData.data.user);
    }

    try {
      const userStr = localStorage.getItem("user");
      if (!userStr) return [];
      return getServicesFromUser(JSON.parse(userStr));
    } catch {
      return [];
    }
  }, [profileData, localVersion]); // eslint-disable-line react-hooks/exhaustive-deps -- localVersion refreshes localStorage fallback

  const hasService = (service) => hasSupplierService(services, service);

  return {
    services,
    hasService,
    user: profileData?.data?.user,
  };
};
